<template>
    <div class="register">
        <label for="user-register" class="form-label"><h5>註冊用戶</h5></label>
        <form @submit.prevent="register">
            <div class="input-group mb-3">
                <span class="input-group-text">姓名</span>
                <input type="text" class="form-control" id="name" placeholder="陳彥良" v-model="name" required>
            </div>
            <div class="input-group mb-3">
                <span class="input-group-text">職稱</span>
                <input type="text" class="form-control" id="position" placeholder="副理" v-model="position" required>
            </div>
            <div class="input-group mb-3">
                <span class="input-group-text">信箱</span>
                <input type="email" class="form-control" id="email" placeholder="twyingmi2016@gmail.com" v-model="email" required>
            </div>
            <div class="input-group mb-3">
                <span class="input-group-text">公司</span>
                <select class="form-select" id="company_id" v-model="company_id" name="company">
                    <option v-for="company in companies" :value="company.id" :key="company.id">{{ company.name }}</option>
                </select>
            </div>
            <div class="input-group mb-3">
                <span class="input-group-text">權限</span>
                <select class="form-select" id="access" name="access" v-model="access">
                    <option v-for="option in options" :key="option.access" :value="option.access">{{option.type}}</option>
                </select>
            </div>
            <div class="d-grid gap-2">
              <button type="submit" class="btn btn-warning">註冊</button>
            </div>
        </form>
    </div>
    <div class="note">
      <span id="title">※密碼為註冊之信箱</span><br/>
      <span id="example">例如: 信箱為test@gmail.com，密碼為test@gmail.com</span>
    </div>
</template>
<script setup>
import axios from 'axios';
import { ref, watch } from 'vue';

const name = ref('');
const position = ref('');
const email = ref('');
const access = ref(3);
const company_id = ref(1);
const companies = ref([
  {id:1, name:'玉霖建設'},
  {id:2, name:'邑舍設紀'},
  {id:3, name:'展璽國際'},
  {id:4, name:'盈米科技'},
  {id:5, name:'晶霖物業'},
  {id:6, name:'晶霖保全'},
  {id:7, name:'晶霖公寓大廈'}
]);
const options = ref([]);
const accessMap = {
  1: [{access: 3, type: '一般職員'}, {access: 4, type: '不簽核主管'}, {access: 5, type: '總經理'},],
  2: [{access: 3, type: '一般職員'}, {access: 4, type: '不簽核主管'}, {access: 5, type: '總監'}],
  3: [{access: 3, type: '一般職員'}, {access: 4, type: '不簽核主管'}, {access: 6, type: '協理'}, {access: 7, type: '經理'}, {access: 8, type: '行政秘書'}],
};
const companyToAccessKey = {
  2: 2,
  5: 3,
  6: 3,
  7: 3,
};

const updateAccess = () => {
  options.value = accessMap[companyToAccessKey[company_id.value] || 1];
};

watch(company_id, updateAccess, { immediate:true });//監聽selectedCompany變化，自動更新options

const register = async () => {
  try {
    const response = await axios.post(
      'https://baofengbooks.com/s_api/public/api/register',
      {
        name: name.value,
        position: position.value,
        email: email.value,
        password: email.value,
        company_id: company_id.value,
        access: access.value
      }
    );
    if(response.data) {
      console.log('註冊成功');
      alert('註冊成功');
      window.location.reload();
    }
  } catch (error) {
    console.error(error.response || error);
    alert('註冊失敗');
  }
};
</script>
<style scoped>
  button{
    font-weight: 600;
  }
  h5{
    font-weight: 600;
  }
  .note{
    text-align: start;
    padding-left: 10px;
    margin-top: 10px;
  }
  #title{
    font-weight: 600;
    font-size: 15px;
    color: rgb(177, 20, 20);
  }
  #example{
    font-weight: 500;
    font-size: 14px;
    color: rgb(114, 114, 114);
  }
</style>
  